import React, { useState } from 'react';
import { Icon } from '@iconify/react';
const initialTemplates = [{
  id: 1,
  nome: 'pubblicazione graduatorie',
  oggetto: 'online le graduatorie dei vincitori'
}, {
  id: 2,
  nome: 'template di prova',
  oggetto: 'prova'
}, {
  id: 3,
  nome: 'Test Template',
  oggetto: 'Test Oggetto'
}];
export function EmailTemplates() {
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({
    nome: '',
    oggetto: ''
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const filteredData = initialTemplates.filter(item => {
    const matchesSearch = item.nome.toLowerCase().includes(searchQuery.toLowerCase()) || item.oggetto.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilters = item.nome.toLowerCase().includes(filters.nome.toLowerCase()) && item.oggetto.toLowerCase().includes(filters.oggetto.toLowerCase());
    return matchesSearch && matchesFilters;
  });
  const handleFilterChange = (key: string, value: string) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };
  return <div style={{
    fontFamily: 'Roboto, sans-serif'
  }} data-id="element-999">
      {/* Page Header */}
      <div className="bg-white flex items-center justify-between" style={{
      padding: '24px 32px',
      border: '1px solid #E4E4E4',
      boxShadow: 'none',
      borderRadius: '8px'
    }} data-id="element-1000">
        <h1 style={{
        fontSize: '24px',
        fontWeight: 400,
        color: '#293B54',
        fontFamily: 'Roboto, sans-serif',
        margin: 0
      }} data-id="element-1001">
          Templates
        </h1>
        <button style={{
        backgroundColor: '#293B54',
        color: '#FFFFFF',
        fontFamily: 'Roboto Condensed, sans-serif',
        fontSize: '14px',
        fontWeight: 400,
        padding: '10px 20px',
        borderRadius: '9999px',
        border: 'none',
        cursor: 'pointer'
      }} onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#1e2b3e'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#293B54'} data-id="element-1002">
          Crea nuovo template
        </button>
      </div>

      {/* Table Container */}
      <div className="bg-white" style={{
      marginTop: '24px',
      padding: '24px',
      border: '1px solid #E4E4E4',
      boxShadow: 'none',
      borderRadius: '8px'
    }} data-id="element-1003">
        {/* Search Row */}
        <div className="flex items-center gap-3 mb-4" data-id="element-1004">
          <div className="relative" style={{
          width: '300px'
        }} data-id="element-1005">
            <Icon icon="tabler:search" fontSize={16} style={{
            position: 'absolute',
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#AAAAAA'
          }} data-id="element-1006" />
            <input type="text" placeholder="Cerca templates..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} style={{
            width: '100%',
            height: '36px',
            paddingLeft: '32px',
            paddingRight: '10px',
            border: '1px solid #E4E4E4',
            borderRadius: '8px',
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif',
            outline: 'none',
            color: '#293B54'
          }} onFocus={e => e.target.style.borderColor = '#293B54'} onBlur={e => e.target.style.borderColor = '#E4E4E4'} data-id="element-1007" />
          </div>
          <button style={{
          width: '36px',
          height: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #E4E4E4',
          background: 'white',
          cursor: 'pointer',
          color: '#666',
          borderRadius: '8px'
        }} onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#f9f9f9'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'white'} data-id="element-1008">
            <Icon icon="tabler:adjustments-horizontal" fontSize={16} data-id="element-1009" />
          </button>
        </div>

        {/* Table */}
        <div style={{
        overflowX: 'auto'
      }} data-id="element-1010">
          <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          minWidth: '600px'
        }} data-id="element-1011">
            <thead data-id="element-1012">
              {/* Header Row */}
              <tr style={{
              backgroundColor: '#FFFFFF'
            }} data-id="element-1013">
                <th style={{
                textAlign: 'left',
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 600,
                color: '#666',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                borderBottom: '2px solid #E4E4E4',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-1014">
                  Nome Template
                </th>
                <th style={{
                textAlign: 'left',
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 600,
                color: '#666',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                borderBottom: '2px solid #E4E4E4',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-1015">
                  Oggetto Email
                </th>
                <th style={{
                textAlign: 'left',
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 600,
                color: '#666',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                borderBottom: '2px solid #E4E4E4',
                fontFamily: 'Roboto, sans-serif',
                width: '120px'
              }} data-id="element-1016">
                  Azioni
                </th>
              </tr>

              {/* Filter Row */}
              <tr data-id="element-1017">
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1018">
                  <input type="text" placeholder="Filtra name..." value={filters.nome} onChange={e => handleFilterChange('nome', e.target.value)} style={{
                  width: '100%',
                  height: '30px',
                  padding: '0 8px',
                  border: '1px solid #E4E4E4',
                  borderRadius: '8px',
                  fontSize: '12px',
                  fontFamily: 'Roboto, sans-serif',
                  color: '#444',
                  outline: 'none'
                }} onFocus={e => e.target.style.borderColor = '#293B54'} onBlur={e => e.target.style.borderColor = '#E4E4E4'} data-id="element-1019" />
                </td>
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1020">
                  <input type="text" placeholder="Filtra email_subject..." value={filters.oggetto} onChange={e => handleFilterChange('oggetto', e.target.value)} style={{
                  width: '100%',
                  height: '30px',
                  padding: '0 8px',
                  border: '1px solid #E4E4E4',
                  borderRadius: '8px',
                  fontSize: '12px',
                  fontFamily: 'Roboto, sans-serif',
                  color: '#444',
                  outline: 'none'
                }} onFocus={e => e.target.style.borderColor = '#293B54'} onBlur={e => e.target.style.borderColor = '#E4E4E4'} data-id="element-1021" />
                </td>
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1022"></td>
              </tr>
            </thead>

            <tbody data-id="element-1023">
              {filteredData.map(row => <tr key={row.id} style={{
              borderBottom: '1px solid #f0f0f0'
            }} onMouseEnter={e => (e.currentTarget as HTMLTableRowElement).style.backgroundColor = '#fafafa'} onMouseLeave={e => (e.currentTarget as HTMLTableRowElement).style.backgroundColor = 'transparent'} data-id="element-1024">
                  <td style={{
                padding: '12px 16px',
                fontSize: '14px',
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-1025">
                    {row.nome}
                  </td>
                  <td style={{
                padding: '12px 16px',
                fontSize: '14px',
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif'
              }} data-id="element-1026">
                    {row.oggetto}
                  </td>
                  <td style={{
                padding: '12px 16px'
              }} data-id="element-1027">
                    <div style={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'center'
                }} data-id="element-1028">
                      <button style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#666',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center'
                  }} onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.color = '#293B54'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.color = '#666'} title="Visualizza" data-id="element-1029">
                        <Icon icon="tabler:eye" fontSize={18} data-id="element-1030" />
                      </button>
                      <button style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#666',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center'
                  }} onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.color = '#293B54'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.color = '#666'} title="Modifica" data-id="element-1031">
                        <Icon icon="tabler:pencil" fontSize={18} data-id="element-1032" />
                      </button>
                      <button style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#666',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center'
                  }} onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.color = '#e53e3e'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.color = '#666'} title="Elimina" data-id="element-1033">
                        <Icon icon="tabler:trash" fontSize={18} data-id="element-1034" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '16px',
        paddingTop: '12px',
        borderTop: '1px solid #E4E4E4',
        marginTop: '4px'
      }} data-id="element-1035">
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '13px',
          color: '#666',
          fontFamily: 'Roboto, sans-serif'
        }} data-id="element-1036">
            <span data-id="element-1037">Righe per pagina:</span>
            <select value={rowsPerPage} onChange={e => setRowsPerPage(Number(e.target.value))} style={{
            border: 'none',
            background: 'transparent',
            fontSize: '13px',
            color: '#666',
            fontFamily: 'Roboto, sans-serif',
            cursor: 'pointer',
            outline: 'none',
            fontWeight: 500
          }} data-id="element-1038">
              <option value={10} data-id="element-1039">10</option>
              <option value={25} data-id="element-1040">25</option>
              <option value={50} data-id="element-1041">50</option>
            </select>
          </div>
          <span style={{
          fontSize: '13px',
          color: '#666',
          fontFamily: 'Roboto, sans-serif'
        }} data-id="element-1042">
            1-{filteredData.length} di {filteredData.length}
          </span>
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '2px'
        }} data-id="element-1043">
            <button disabled style={{
            background: 'none',
            border: 'none',
            cursor: 'not-allowed',
            color: '#666',
            opacity: 0.4,
            padding: '4px',
            display: 'flex',
            alignItems: 'center'
          }} data-id="element-1044">
              <Icon icon="tabler:chevron-left" fontSize={20} data-id="element-1045" />
            </button>
            <button disabled style={{
            background: 'none',
            border: 'none',
            cursor: 'not-allowed',
            color: '#666',
            opacity: 0.4,
            padding: '4px',
            display: 'flex',
            alignItems: 'center'
          }} data-id="element-1046">
              <Icon icon="tabler:chevron-right" fontSize={20} data-id="element-1047" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}